import React from "react";

import styles from "./button.module.css";

const Button = ({
  backgroundColor,
  height,
  width,
  color,
  txt,
  onClick,
  opacity,
  pointerEvents,
  new_styles,
  newStyles,
  isInThePast,
  minHeight,
  className
}) => {
  return (
    <button
      className={`${styles.warnerStayButton} ${isInThePast ? "disableElement" : ""} ${className}`}
      style={{
        backgroundColor,
        height,
        color,
        opacity,
        pointerEvents,
        width,
        minHeight,
        ...new_styles,
        ...newStyles,
      }}
      onClick={onClick}
    >
      {txt}
    </button>
  );
};

export default Button;
